<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.fm.furnaceMeasureEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/smeltingFurnaceMeasure"><span>{{$t('tlt.furnaceMeasure')}}</span></router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/prd/furnaceMeasureEdit"><span>{{$t('tlt.fm.furnaceMeasureEdit')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('smeltingFurnaceMeasure')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('smeltingFurnaceMeasure')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.date')}}：</label>
                                <mmf-datepicker v-model="day"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.datetime')}}:</label>
                                <!-- <input class="form-control form-control-sm" type="timepicker" name="time" v-model="time"> -->
                                <mes-time-picker v-model="time"></mes-time-picker>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <!-- <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.locationName')}}：</label>
                                <select class="form-control" type="text" v-model="locName">
                                    <option value>{{$t("lbl.basic.select.one")}}</option>
                                    <option value="冶炼一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                                    <option value="冶炼二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                                    <option value="冶炼三期">{{$t('lbl.basic.plant.smelting2')}}</option>
                                </select>
                            </div> -->
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.shiftPlan.shiftName')}}：</label>
                                <select class="form-control" v-model="shift" name="shift" v-validate="'required'">
                                        <option value>{{$t("lbl.basic.select.one")}}</option>
                                        <option value="甲">{{ $t("lbl.shift.A") }}</option>
                                        <option value="乙">{{ $t("lbl.shift.B") }}</option>
                                        <option value="丙">{{ $t("lbl.shift.C") }}</option>
                                </select>
                                <span v-show="errors.has('shift')" class="lbl-obg">
                                    {{errors.first('shift')}}
                                </span> 
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("lbl.basic.furnaceName")}}：</label>
                                <select class="form-control" v-model="furnaceNumber" v-validate="'required'" name="furnaceNumber">
                                        <option value>{{$t("lbl.basic.select.one")}}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1")}}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2")}}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3")}}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4")}}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5")}}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6")}}</option>
                                </select>
                                <span v-show="errors.has('furnaceNumber')" class="lbl-obg">
                                    {{errors.first('furnaceNumber')}}
                                </span> 
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise1')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="rise1" name="rise1" v-validate="'required'">
                                <span v-show="errors.has('rise1')" class="lbl-obg">
                                    {{errors.first('rise1')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset1')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset1" type="text" v-validate="'required'" name="offset1">
                                <span v-show="errors.has('offset1')" class="lbl-obg">
                                    {{errors.first('offset1')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise2')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise2" type="text" name="rise2" v-validate="'required'">
                                <span v-show="errors.has('rise2')" class="lbl-obg">
                                    {{errors.first('rise2')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset2')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset2" type="text" name="offset2" v-validate="'required'">
                                <span v-show="errors.has('offset2')" class="lbl-obg">
                                    {{errors.first('offset2')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise3')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise3" type="text" name="rise3" v-validate="'required'">
                                <span v-show="errors.has('rise3')" class="lbl-obg">
                                    {{errors.first('rise3')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset3')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset3" type="text" v-validate="'required'" name="offset3">
                                <span v-show="errors.has('offset3')" class="lbl-obg">
                                    {{errors.first('offset3')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise4')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise4" type="text" v-validate="'required'" name="rise4">
                                <span v-show="errors.has('rise4')" class="lbl-obg">
                                    {{errors.first('rise4')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset4')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset4" type="text" v-validate="'required'" name="offset4">
                                <span v-show="errors.has('offset4')" class="lbl-obg">
                                    {{errors.first('offset4')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise5')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise5" type="text" v-validate="'required'" name="rise5">
                                <span v-show="errors.has('rise5')" class="lbl-obg">
                                    {{errors.first('rise5')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset5')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset5" type="text" v-validate="'required'" name="offset5">
                                <span v-show="errors.has('offset5')" class="lbl-obg">
                                    {{errors.first('offset5')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise6')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise6" type="text" v-validate="'required'" name="rise6">
                                <span v-show="errors.has('rise6')" class="lbl-obg">
                                    {{errors.first('rise6')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset6')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset6" type="text" v-validate="'required'" name="offset6">
                                <span v-show="errors.has('offset6')" class="lbl-obg">
                                    {{errors.first('offset6')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise7')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise7" type="text" v-validate="'required'" name="rise7">
                                <span v-show="errors.has('rise7')" class="lbl-obg">
                                    {{errors.first('rise7')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset7')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset7" type="text" v-validate="'required'" name="offset7">
                                <span v-show="errors.has('offset7')" class="lbl-obg">
                                    {{errors.first('offset7')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise8')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise8" type="text" v-validate="'required'" name="rise8">
                                <span v-show="errors.has('rise8')" class="lbl-obg">
                                    {{errors.first('rise8')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset8')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset8" type="text" v-validate="'required'" name="offset8">
                                <span v-show="errors.has('offset8')" class="lbl-obg">
                                    {{errors.first('offset8')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise9')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise9" type="text" v-validate="'required'" name="rise9">
                                <span v-show="errors.has('rise9')" class="lbl-obg">
                                    {{errors.first('rise9')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset9')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset9" type="text" v-validate="'required'" name="offset9">
                                <span v-show="errors.has('offset9')" class="lbl-obg">
                                    {{errors.first('offset9')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise10')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise10" type="text" v-validate="'required'" name="rise10">
                                <span v-show="errors.has('rise10')" class="lbl-obg">
                                    {{errors.first('rise10')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset10')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset10" type="text" v-validate="'required'" name="offset10">
                                <span v-show="errors.has('offset10')" class="lbl-obg">
                                    {{errors.first('offset10')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise11')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise11" type="text" v-validate="'required'" name="rise11">
                                <span v-show="errors.has('rise11')" class="lbl-obg">
                                    {{errors.first('rise11')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset11')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset11" type="text" v-validate="'required'" name="offset11">
                                <span v-show="errors.has('offset11')" class="lbl-obg">
                                    {{errors.first('offset11')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.rise12')}}：</label>
                                <input class="form-control form-control-sm" v-model="rise12" type="text" v-validate="'required'" name="rise12">
                                <span v-show="errors.has('rise12')" class="lbl-obg">
                                    {{errors.first('rise12')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.offset12')}}：</label>
                                <input class="form-control form-control-sm" v-model="offset12" type="text" v-validate="'required'" name="offset12">
                                <span v-show="errors.has('offset12')" class="lbl-obg">
                                    {{errors.first('offset12')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.principal')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="principal" v-validate="'required'" name="principal">
                                <span v-show="errors.has('principal')" class="lbl-obg">
                                    {{errors.first('principal')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.remark')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="remark" v-validate="'required'" name="remark">
                                <span v-show="errors.has('remark')" class="lbl-obg">
                                    {{errors.first('remark')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions, mapState,
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionExecution/smelting/SmeltingFurnaceMeasure";
    import MmfDatepicker from '@/components/MmfDatepicker';
    import MesTimePicker from '@/components/MesTimePicker';
    import dimSearch from "@/components/MMFDimSearch";

    const {
        mapFields
    } = createHelpers({
        getterType: 'smeltingFurnaceMeasure/getField',
        mutationType: 'smeltingFurnaceMeasure/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
            this.$store.dispatch('smeltingFurnaceMeasure/loadLocations');
        },
    computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.smeltingFurnaceMeasure.locations
            }),
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            MmfDatepicker,
            MesTimePicker,
            dimSearch
        }
};
</script>